var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"haed"},[_c('div',{staticClass:"tit_box"},[_vm._v(_vm._s(_vm.tit))]),_c('span',{staticClass:"dateTime"},[_vm._v(_vm._s(_vm.date)+" "+_vm._s(_vm.time)+" "+_vm._s(_vm.weekAll[_vm.week]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }